<router-outlet></router-outlet>
<div class="overlay" *ngIf="globalLoader">
  <mat-spinner color="primary"></mat-spinner>
</div>
